import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-link-manual',
  templateUrl: './link-manual.component.html',
  styleUrls: ['./link-manual.component.scss']
})
export class LinkManualComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
